import { FilterGroupState } from "features/ui/Filters/FilterBuilder/types";
import { FilterOperator } from "features/ui/Filters/types";

// Matches events that belong to no smart group ("smartGroups is null"). Drives
// the ungrouped bucket and scopes the ungrouped "Investigate" action on both
// the Dashboard and SchemaDashboard.
export const UNGROUPED_SMART_GROUPS_FILTER: FilterGroupState = {
  type: "group",
  id: "ungrouped-smart-groups-filter",
  anyAll: "all",
  children: [
    {
      type: "row",
      id: "ungrouped-smart-groups-filter-row",
      attribute: "smartGroups",
      operator: FilterOperator.IS_EMPTY,
      values: ["null"],
    },
  ],
};
